import { render } from "./MessageRecord.vue?vue&type=template&id=410b62f5&scoped=true"
import script from "./MessageRecord.vue?vue&type=script&lang=js"
export * from "./MessageRecord.vue?vue&type=script&lang=js"

import "./MessageRecord.vue?vue&type=style&index=0&id=410b62f5&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-410b62f5"]])

export default __exports__